import { render, staticRenderFns } from "./PotentialResourcesPlatformUser.vue?vue&type=template&id=5618b99f&scoped=true&"
import script from "./PotentialResourcesPlatformUser.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesPlatformUser.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesPlatformUser.vue?vue&type=style&index=0&id=5618b99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618b99f",
  null
  
)

export default component.exports